import React from "react";
export default {
    bars: (
        <div className="tq-bars-preloader">
            <div className="tq-loading-bar" />
            <div className="tq-loading-bar" />
            <div className="tq-loading-bar" />
            <div className="tq-loading-bar" />
        </div>
    ),
    label: (
        <div className="tq-second-preloader" data-preloader="asymetric">
            <span>"Loading..."</span>
        </div>
    ),
    clock: (
        <div className="tq-clock-loader">
            <div className="tq-loader-hours-container">
                <div className="tq-loader-hours" />
            </div>
            <div className="tq-loader-dot" />
            <div className="tq-loader-minutes-container">
                <div className="tq-loader-minutes" />
            </div>
        </div>
    ),
    "tinqin-logo": (
        <div className="tq-tinqin-logo-preloader">
            <div className="tq-gr-1">
                <div className="tq-gr-1-sq" />
                <div className="tq-gr-1-tr" />
            </div>
            <div className="tq-gr-2">
                <div className="tq-gr-2-sq" />
                <div className="tq-gr-2-tr" />
            </div>
            <div className="tq-gr-3">
                <div className="tq-gr-5">
                    <div className="tq-gr-5-sq" />
                    <div className="tq-gr-5-tr" />
                </div>
                <div className="tq-gr-4">
                    <div className="tq-gr-4-sq" />
                    <div className="tq-gr-4-tr" />
                </div>
            </div>
            <div className="tq-red-square-container">
                <div className="tq-red-square" />
            </div>
        </div>
    )
};
